import { formatEndpoint } from "@onhandtech/onhand-fe-shared/lib/request";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getConfig } from "config/configuration";
import { deleteCampaignPermission } from "redux/redux-modules";
import { all, put } from "redux-saga/effects";

import type { UnpublishCampaignActionPayload } from "../actions";

export function* unpublishCampaignSaga({
	payload: { campaign },
}: PayloadAction<UnpublishCampaignActionPayload>) {
	const permissions = campaign.permissionAssignments;

	console.log("Unpublish saga: ", permissions);

	const { endpoints } = getConfig();

	const deleteRequests = permissions.map(({ id }) =>
		put(
			deleteCampaignPermission.actions.makeRequest({
				url: formatEndpoint(endpoints.api.v5.campaignDeletePermissions, { id }),
			}),
		),
	);

	yield all(deleteRequests);
}
